import React, { useEffect, useState, useRef } from "react";
import { useIdleTimer } from 'react-idle-timer'
import {
  Row,
  Col,
  Button,
  Divider,
  Card,
  Spin,
  Modal,
  List,
  Typography,
  Alert,
  message,
} from "antd";
//refresh token
import { useHistory } from "react-router-dom";
import { CognitoUserPool } from "amazon-cognito-identity-js";
import AWS from "aws-sdk";
import { WarningFilled } from '@ant-design/icons';
import variables from "../../variables.scss";
import { useSelector, useDispatch } from "react-redux";
import { wsConnect, wsDisconnect, wsSend, } from "../../store/pushback";
// import session, { updateUser, restoreSession, getKillSwitchInfo, getSessionInfo, exportTokenInfo } from "../../store/session";
import { updateUser, restoreSession, getKillSwitchInfo, getSessionInfo, exportTokenInfo } from "../../store/session";
// import icon_location from "../../assets/images/icon_location.svg";
import arrow_dropdown from "../../assets/images/arrow_white.png";
import icon_user from "../../assets/images/icon_user.svg";
// import refresh_icon from "../../assets/images/refresh_icon3.png";
import icon_info from "../../assets/images/icon_info.svg";
// import icon_anchor1 from "../../assets/images/icon_anchor1.svg";
// import icon_gif from "../../assets/images/icon_gif.svg";
import info_icon from "../../assets/images/info_icon.svg";
import check_icon from "../../assets/images/check_icon.svg";
import close_icon from "../../assets/images/close_icon.svg";
import icon_check from "../../assets/images/icon_check.svg";
import icon_warning from "../../assets/images/icon_warning.png";
import icon_hand from "../../assets/images/icon_hand.svg";
// import icon_refresh from "../../assets/images/refresh.svg";
// import icon_refresh from "../../assets/images/refresh_blue.svg";
import app_logo from "../../assets/images/app_logo.png";
import clockwise_icon from "../../assets/images/clockwise.png";
import counter_icon from "../../assets/images/counter-clockwise.png";
import audio_alerm_clock from "../../assets/audio/audio_alerm_clock.mp3";
// import Maintenance from "../Maintenance";
// import static_image from "../../assets/images/c16_facenorth.gif";
import constants from "../../configs/constants";
import moment from "moment";
import {
  getDistanceFromLatLonInKm,
  sortByKey,
  doesFileExist,
} from "../../configs/utils";
import { usePrevious } from "../../hooks/usePrevious";

const styles = {
  container: {
    minHeight: "100vh",
    padding: "70px 20px 30px 20px",
    background: "#2D3C52",
  },
  rowHeader: { textAlign: "center", color: "#9DA2A8", fontSize: 12 },
  row: {
    textAlign: "center",
    color: "#434343",
    fontSize: 15,
  },
  card: {
    marginTop: "1em",
    borderRadius: 10,
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
  card1: {
    height: "311px",
    marginTop: "1em",
    borderRadius: 10,
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  },
  divider: {
    background: "rgba(255, 255, 255, 0.5)",
    height: 16,
    top: 3,
  },
  baySelect: {
    width: 260,
    height: 50,
    borderRadius: 5,
    background: "#1C60E5",
    color: "#434343",
    textAlign: "center",
  },
};

const Driver = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const tokenInfo = useSelector((state) => state.session.tokenInfo);
  const tokenInfoError = useSelector((state) => state.session.tokenInfoError);
  const wsOpened = useSelector((state) => state.pushback.wsOpened);
  const wsDisconnected = useSelector((state) => state.pushback.wsDisconnected);
  const getUpdateDataTime = useSelector((state) => state.pushback.getUpdateDataTime);
  const gatesData = useSelector((state) => state.pushback.gatesData);
  const updateValidateData = useSelector((state) => state.pushback.updateValidateData);
  const error = useSelector((state) => state.pushback.error);
  const error_message = useSelector((state) => state.session.error);
  const sessionInfo = useSelector((state) => state.session.sessionInfo);
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingImg, setLoadingImg] = useState(false);
  const [activeGateListByDistance, setActiveGateListByDistance] = useState([]);
  const [selectedGate, setSelectedGate] = useState();
  const pushbackMapping = useSelector((state) => state.session.pushbackMapping);
  const airlineCodeMapping = useSelector(
    (state) => state.session.airlineCodeMapping
  );
  const switchData = useSelector((state) => state.pushback.switchData);
  const switchDataMessage = useSelector((state) => state.session.switchDataMessage);
  
  const [pushbackData, setPushbackData] = useState();
  const [originalPushbackData, setOriginalPushbackData] = useState([]);
  const [displayGateList, setDisplayGateList] = useState(false);
  const [showMismatchPopup, setShowMismatchPopup] = useState(false);
  const [abortFlagValue, setAbortFlagValue] = useState(false);
  const [loadingInstruction, setLoadingInstruction] = useState({
    status: false,
    data: null,
  });
  const progressDiv = useRef(null);
  const popupAudio = useRef(null);
  const hiddenButton = useRef(null);
  const prevWSOpened = usePrevious(wsOpened);
  const [showInformationPopup, setShowInformationPopup] = useState(false);
  //confirmation popup
  const [
    showConfirmationPushbackPopup,
    setShowConfirmationPushbackPopup,
  ] = useState(false);
  const [confirmationInstruction, setconfirmationInstruction] = useState({
    bay: null,
    instruction: null,
  });
  const [selectedClass, setSelectedClass] = useState();
  const [passConfirmation, setPassConfirmation] = useState(false);

  const [showAirplaneRoute, setShowAirplaneRoute] = useState({
    flag: false,
    filePath: null,
  });
  const [showAirplaneRouteModal, setShowAirplaneRouteModal] = useState(false);
  const [newGateSelected, setNewGateSelected] = useState(false);

  const [gpsDisplay, setGpsDisplay] = useState(false);
  const [sortedGPSValue, setSortedGPSValue] = useState(false);
  const [gpsSelectedBay, setGpsSelectedBay] = useState();
  const [previousIntervalID, setPreviousIntervalID] = useState();
  const [filterGatesList, setFilterGatesList] = useState();

  const [userLocal, setUserLocal] = useState(
    JSON.parse(localStorage.getItem("driverToken"))
  );
  // const [userLocal, setUserLocal] = useState(JSON.parse(sessionStorage.getItem("driverSession")));
  const [errorDisplay, setErrorDisplay] = useState(false);
  const [gateLocal, setGateLocal] = useState(
    JSON.parse(localStorage.getItem("gateSelected"))
  );
  const [checkConnection, setCheckConnection] = useState(false);
  const [errorSessionDisplay, setErrorSessionDisplay] = useState(false);
  const prevAirportRoute = usePrevious(showAirplaneRoute);

  const [selectedInstruction, setSelectedInstruction] = useState(0);

  // show mismatch if new instruction is checked
  const [showInstructionMismatchPopup, setShowInstructionMismatchPopup] = useState(false);
  const [instructionSelected, setInstructionSelected] = useState();
  const prevInstructionSelected = usePrevious(instructionSelected);
  const [bayInstructionSelected, setBayInstructionSelected] = useState();
  const prevBayInstructionSelected = usePrevious(bayInstructionSelected);

  const [previousInstruction, setPreviousInstruction] = useState();
  const [previousPushback, setPreviousPushback] = useState();
  const [loadingSelected, setLoadingSelected] = useState(false);
  const [loadingPopup, setLoadingPopup] = useState(false);

  //disconnect websockets
  const [socketsDisconnect, setSocketsDisconnect] = useState(false);

  // rotate value
  const [rotateClockwiseValue, setRotateClockwiseValue] = useState(0);
  // const [confirmSelectedInstruction, setConfirmSelectedInstruction] = useState(false);
  //existing instruction popup
  const [
    showExistingPushbackPopup,
    setShowExistingPushbackPopup,
  ] = useState(false);

  // idleTimer
  const idleTimerRef = useRef(null);
  const [idleState, setIdleState] = useState('Active')
  const [remaining, setRemaining] = useState(0);
  const [timeModalOpen, setTimeModalOpen] = useState();

  // delete marker
  const [gateNotExisting, setGateNotExisting] = useState(false);

  // toggle switch
  const [toggleSwitch, setToggleSwitch] = useState(false);
  const [switchDataMessageLocal, setSwitchDataMessageLocal] = useState(
    localStorage.getItem("switchStatus")
  );

  // pushback mapping data
  const [mappingData, setMappingData] = useState();

  // show disconnection btn
  const [showRefreshBtn, setShowRefreshBtn] = useState(false);


  // cognito Sweet data
  const [cognitoSweetData, setCognitoSweetData] = useState();

  // useEffect(() => {
  //   if (error && error === 'No file found in S3 bucket') {
  //     console.log('run error')
  //     setToggleSwitch(true);
  //       dispatch(wsDisconnect()); //disconnect websocket
  //       dispatch(updateUser(null)); //logout -> clear user data
  //       window.localStorage.removeItem("driverAccessToken");
  //       window.localStorage.removeItem("driverToken");
  //       // sessionStorage.removeItem('driverSession');
  //       window.localStorage.removeItem("gateSelected");
  //       props.history.push("/");
  //       console.log('switchData hello 2')
  //   } else {
  //     setToggleSwitch(false);
  //   }
  // }, [error]);

  // useEffect(() => {
  //   if (error_message && error_message === 'No file found in S3 bucket') {
  //     console.log('run error 2')
  //     setToggleSwitch(true);
  //       dispatch(wsDisconnect()); //disconnect websocket
  //       dispatch(updateUser(null)); //logout -> clear user data
  //       window.localStorage.removeItem("driverAccessToken");
  //       window.localStorage.removeItem("driverToken");
  //       // sessionStorage.removeItem('driverSession');
  //       window.localStorage.removeItem("gateSelected");
  //       props.history.push("/");
  //       console.log('switchData hello 2')
  //   } else {
  //     setToggleSwitch(false);
  //   }
  // }, [error_message]);

  useEffect(() => {
    // setTimeout(() => {
    //   dispatch(getKillSwitchInfo({message: 'getS3Message'}));
    //   reloadPage();
    // }, 60000);

    
    dispatch(getKillSwitchInfo({message: 'getS3Message'}));
    // console.log('switch message call 2')
    
    const switchDataStatus = window.localStorage.getItem("switchStatus");
    if (switchDataStatus) {
      setSwitchDataMessageLocal(switchDataStatus)
    }

    // SWEET
    const getSessionId = window.localStorage.getItem("driverSessionId");

    if (getSessionId) {
      setTimeout(() => {
        dispatch(getSessionInfo({session_id: getSessionId}));
      }, 1000);
      // console.log('sessionInfo 1', getSessionId);
    }

    // run encryptToken API

    const getAccessTokenLocal = window.localStorage.getItem("driverAccessToken");

    if (getAccessTokenLocal) {
      setTimeout(() => {
        // dispatch(exportTokenInfo({access_token: getAccessTokenLocal}));
        dispatch(exportTokenInfo({access_token: getAccessTokenLocal}));
      }, 1000);
    }
    
    
  }, []);

  // checks local storage 
  // useEffect(() => {
  //   if (switchDataMessageLocal) {
  //     console.log('switchData message', switchDataMessageLocal);
  //     console.log('switchData message', switchDataMessageLocal === 'ON');
  //     if (switchDataMessageLocal === 'ON') {
  //       props.history.push("/");
  //       console.log('switchData message props.history')
  //       setToggleSwitch(true);
  //       dispatch(updateUser(null)); //logout -> clear user data
  //       dispatch(wsDisconnect()); //disconnect websocket
  //       window.localStorage.removeItem("driverAccessToken");
  //       window.localStorage.removeItem("driverToken");
  //       // sessionStorage.removeItem('driverSession');
  //       window.localStorage.removeItem("gateSelected");
  //     } else {
  //       setToggleSwitch(false)
  //     }
  //   }

  // }, [switchDataMessageLocal]);


  // listens to websocket
  useEffect(() => {
    if (switchData) {
      // console.log('switchData driver', switchData);
      if (switchData[0].status === 'ON') {
        setToggleSwitch(true);
        // window.location.replace('/')
        // return <Redirect to='/' />
        // history.push('/')
        // logoutUser();
        dispatch(wsDisconnect()); //disconnect websocket
        // dispatch(updateUser(null)); //logout -> clear user data
        // window.localStorage.removeItem("driverAccessToken");
        // window.localStorage.removeItem("driverToken");
        // // sessionStorage.removeItem('driverSession');
        // window.localStorage.removeItem("gateSelected");
        props.history.push("/maintenance");
        // console.log('switchData hello')
      } else {
        setToggleSwitch(false)
      }
    }
  }, [switchData]);

  // listen to api data
  useEffect(() => {
    if (switchDataMessage) {
      // console.log('switchData driver 2', switchDataMessage);
      if (switchDataMessage.status === 'ON') {
        setToggleSwitch(true);
        // window.location.replace('/')
        // return <Redirect to='/' />
        // history.push('/')
        // logoutUser();
        dispatch(wsDisconnect()); //disconnect websocket
        // dispatch(updateUser(null)); //logout -> clear user data
        // window.localStorage.removeItem("driverAccessToken");
        // window.localStorage.removeItem("driverToken");
        // // sessionStorage.removeItem('driverSession');
        // window.localStorage.removeItem("gateSelected");
        props.history.push("/maintenance");
        // console.log('switchData hello');
      } else {
        setToggleSwitch(false)
      }
    }
  }, [switchDataMessage]);

  // export token API main message error
  useEffect(() => {
    if (tokenInfoError) {
      console.log('tokenInfoError', tokenInfoError);
      message.error(tokenInfoError);
    }
  }, [tokenInfoError]);

  // export token API error 400, 500, 403, 502
  useEffect(() => {
    if (tokenInfo && tokenInfo.message) {
      console.log('tokenInfo', tokenInfo);
      if (tokenInfo.message === 'access_token parameter is missing.') {
        message.error('Missing required parameter. Please supply the missing parameter.');
      } else {
        message.error(tokenInfo.message);
      }
      
    }
  }, [tokenInfo]);

  useEffect(() => {
    if (switchDataMessageLocal) {
      // console.log('switchData message', switchDataMessageLocal);
      // console.log('switchData message 2', switchDataMessageLocal === 'ON');
      if (switchDataMessageLocal === 'ON') {
        if (user) {
          console.log('switchData message props.history');
          setToggleSwitch(true);
          // dispatch(updateUser(null)); //logout -> clear user data
          dispatch(wsDisconnect()); //disconnect websocket
          // window.localStorage.removeItem("driverAccessToken");
          // window.localStorage.removeItem("driverToken");
          // // sessionStorage.removeItem('driverSession');
          // window.localStorage.removeItem("gateSelected");
          props.history.push("/");
        }
      } else {
        setToggleSwitch(false);
        if (user && tokenInfo) {
          let token = tokenInfo.encrypted_access_token;
          console.log('tokenInfo 1');
            //once user successfully logged in connect with web socket
            // let websocketURL = constants.SOCKET_ROOT_URL + user.accessToken.jwtToken;
            let websocketURL = constants.SOCKET_ROOT_URL + encodeURIComponent(token);
            setTimeout(() => {
              dispatch(wsConnect(websocketURL));
            }, 20000);
            
          } 
      }
    }

  }, [switchDataMessageLocal]);

  useEffect(() => {
    // console.log("DRIVER FIRST");
    if (user && tokenInfo) {
      let token = tokenInfo.encrypted_access_token;
      
      //once user successfully logged in connect with web socket
      // let websocketURL = constants.SOCKET_ROOT_URL + user.accessToken.jwtToken;
      console.log('tokenInfo 2');
      let websocketURL = constants.SOCKET_ROOT_URL + encodeURIComponent(token);

      dispatch(wsConnect(websocketURL));
    }
  }, [user, tokenInfo]);

  useEffect(() => {
    if (getUpdateDataTime) {
      let todaysTime = moment();
      setInterval(() => {
        // console.log("Heartbeat: fetch gates data");
        // dispatch(wsSend({ action: constants.ACTION_GET_GATES_DATA }));
        // // dispatch(wsSend({ action: constants.ACTION_ON_GET_S3_MESSAGE }));
        // setErrorDisplay(true);
        if (todaysTime.diff(getUpdateDataTime, "minutes") > 2) {
          console.log('timeeeee!');
        }
      }, 1000);
      
    }
  }, []);

  // on load from local storage
  useEffect(() => {
    // console.log("DRIVER SECOND");
    if (userLocal) {

      dispatch(restoreSession());
      // console.log("RESTORE SESSION");

      if (tokenInfo) {
        let token = tokenInfo.encrypted_access_token;
        console.log('tokenInfo 3');
  
        //once user successfully logged in connect with web socket
        const getToken = window.localStorage.getItem("driverAccessToken");
        // let websocketURL = constants.SOCKET_ROOT_URL + getToken;
        let websocketURL = constants.SOCKET_ROOT_URL + token;
  
        dispatch(wsConnect(websocketURL));
        dispatch(updateUser(userLocal));
  
        //store the userlocal from the local storage to the user store
      }
     
    }
  }, []);

  // on load get gateSelected from local storage
  useEffect(() => {
    // console.log("DRIVER SECOND");
    if (gateLocal) {
      //once user successfully logged in connect with web socket
      let existingGateStorage = window.localStorage.getItem("gateSelected");
      existingGateStorage = existingGateStorage
        ? JSON.parse(existingGateStorage)
        : {};

      //set selected gate if there is existing data in localstorage
      setSelectedGate(existingGateStorage);
    }
  }, []);

  // useEffect(() => {
  //   // console.log("DRIVER SECOND");
  //   if (originalPushbackData && gateLocal) {
  //     //once user successfully logged in connect with web socket
  //     let existingGateStorage = window.localStorage.getItem("gateSelected");
  //     existingGateStorage = existingGateStorage
  //       ? JSON.parse(existingGateStorage)
  //       : {};

  //       const getExistingGate = originalPushbackData.filter( 
  //         item => item.call_sign === gateLocal.call_sign
  //       );
          
  //       if (getExistingGate.length === 0) {
  //         console.log('existing gate local call sign wala');
  //         // setSelectedGate();
  //         // setGateLocal();
  //         // window.localStorage.removeItem("gateSelected");
  //       } else {
  //         console.log('existing gate local call sign meron');
  //         // setSelectedGate(existingGateStorage);
  //       }
  
  //       console.log('existing gate local call sign', getExistingGate);

  //     //set selected gate if there is existing data in localstorage
  //     // setSelectedGate(existingGateStorage);
  //     console.log('gate Local call sign', gateLocal.call_sign)
  //   }
  // }, [originalPushbackData]);

  useEffect(() => {
    if (originalPushbackData && selectedGate) {

      // push the ssame instruction

      // if (selectedGate.previous_pushback_instruction_driver) {

      //   setPreviousPushback(selectedGate.previous_pushback_instruction_driver)

      // }
      

      // if (selectedGate.pushback_instruction_driver) {
      //   setInstructionSelected(selectedGate.pushback_instruction_driver);
      //   setBayInstructionSelected(selectedGate.bay);
      // } else {
      //   setInstructionSelected('');
      //   // setBayInstructionSelected(selectedGate.bay);
      // }

      //got new pushback data and driver already selected one gate then
      //refresh selected gate data based on new pushback dataset
      let updatedSelectedGate = originalPushbackData.filter(
        (e) => e.bay === selectedGate.bay
      );
      console.log("selected gate status", updatedSelectedGate);
      if (updatedSelectedGate.length > 0) {
        // console.log("prev status", selectedGate.status);
        // console.log("updated selected status", updatedSelectedGate[0]);
        // console.log("curr status", updatedSelectedGate[0].status);

        setGateNotExisting(false);
        setSelectedGate({
          ...updatedSelectedGate[0],
          prevstatus: selectedGate.status,
        });

        // console.log("selected gate status 1", updatedSelectedGate[0]);
        if (
          updatedSelectedGate[0].message_type ==
            constants.ACTION_UPDATE_VALIDATE_INSTRUCTION &&
          updatedSelectedGate[0].status == "D"
        ) {
          console.log("button pressed!!!!");
          if (updatedSelectedGate[0].pushback_instruction_driver) {
            let animation = "";
            if (
              updatedSelectedGate[0].pushback_instruction_driver ===
              updatedSelectedGate[0].app_pushback_instruction_1
            ) {
              animation =
                updatedSelectedGate[0].app_pushback_instruction_1_animation;
            }

            if (
              updatedSelectedGate[0].pushback_instruction_driver ===
              updatedSelectedGate[0].app_pushback_instruction_2
            ) {
              animation =
                updatedSelectedGate[0].app_pushback_instruction_2_animation;
            }

            if (
              updatedSelectedGate[0].pushback_instruction_driver ===
              updatedSelectedGate[0].app_pushback_instruction_3
            ) {
              animation =
                updatedSelectedGate[0].app_pushback_instruction_3_animation;
            }
            console.log("clicked button pressed!!!!");
            console.log("clicked instruction:", showAirplaneRoute);
            // open airplane instruction for matched atc and driver instruction
            // if (
            //   (updatedSelectedGate[0].bay === selectedGate.bay &&
            //     updatedSelectedGate[0].pushback_instruction_driver ===
            //       updatedSelectedGate[0].pushback_instruction_atc) ||
            //   updatedSelectedGate[0].pushback_instruction_driver
            // ) {
            if (
              updatedSelectedGate[0].bay === selectedGate.bay &&
                updatedSelectedGate[0].pushback_instruction_driver
            ) {
              // console.log("clicked instruction samee:", showAirplaneRoute);
              console.log(
                "clicked instruction bay:",
                updatedSelectedGate[0].bay === selectedGate.bay
              );
              setTimeout(() => {
                let filePath = constants.MEDIA_PATH + animation + ".gif";
                // let filePath = static_image;
                if (doesFileExist(filePath)) {
                  console.log("clicked instruction airport file", doesFileExist(filePath));
                  setShowAirplaneRoute({
                    flag: true,
                    filePath: filePath,
                  });
                  setShowAirplaneRouteModal(true);
                } else {
                  filePath = constants.MEDIA_PATH + animation + ".pdf";

                  if (doesFileExist(filePath)) {
                    // console.log("airport file", doesFileExist(filePath));
                    window.open(filePath);
                  }
                }
              }, 1000);
            }

            // addded for pop up error
            // setInstructionSelected(updatedSelectedGate[0].pushback_instruction_driver);
            // setBayInstructionSelected(updatedSelectedGate[0].bay);


            // if (selectedGate.previous_pushback_instruction_driver) {

            //   setPreviousPushback(selectedGate.previous_pushback_instruction_driver)
      
            // }

          }
        }
      } 
      // delete markerrrrr
      else {
        console.log('updatedGate 2');
        setGateNotExisting(true);

        //get gate local storage
        let existingGateStorage = window.localStorage.getItem("gateSelected");
        existingGateStorage = existingGateStorage
          ? JSON.parse(existingGateStorage)
          : {};

          // let jsonObj = existingGateStorage
          // ? JSON.parse(existingGateStorage)
          // : {};
          // console.log('updatedGate jsonObj', existingGateStorage);

          // edit object 
          existingGateStorage.aircraft_type = "-";
          existingGateStorage.targeted_offblock_time = "-";
          existingGateStorage.startupapproval_time = "-";
          existingGateStorage.registration = "-";
          existingGateStorage.call_sign = "-";
          existingGateStorage.status = "-";
          existingGateStorage.app_pushback_instruction_1 = "";
          existingGateStorage.app_pushback_instruction_2 = "";
          existingGateStorage.app_pushback_instruction_3 = "";
          existingGateStorage.app_pushback_instruction_1_animation = "";
          existingGateStorage.app_pushback_instruction_2_animation = "";
          existingGateStorage.app_pushback_instruction_3_animation = "";
          // console.log('updatedGate jsonObj 2', existingGateStorage);

        // store updated selected gate
        let newGateStorage = existingGateStorage;
        setSelectedGate(newGateStorage);

        //set selected gate if there is existing data in localstorage
        setGateLocal(newGateStorage);
        window.localStorage.setItem(
          "gateSelected",
          JSON.stringify(newGateStorage)
        );

      }
    }
    // console.log("original pushback", originalPushbackData);
  }, [originalPushbackData]);

  useEffect(() => {
    // console.log("DRIVER THIRD");
    console.log("wsOpened", wsOpened);
    if (!prevWSOpened && wsOpened) {
      dispatch(wsSend({ action: constants.ACTION_GET_GATES_DATA }));
      // dispatch(wsSend({ action: constants.ACTION_ON_GET_S3_MESSAGE }));
      setInterval(() => {
        console.log("Heartbeat: fetch gates data");
        dispatch(wsSend({ action: constants.ACTION_GET_GATES_DATA }));
        // dispatch(wsSend({ action: constants.ACTION_ON_GET_S3_MESSAGE }));
        setErrorDisplay(true);
      }, constants.HEARTBEAT_INTERVAL);

      setInterval(() => {
        console.log("Triggering Re fetch");
        setRefetch(Math.random());
      }, 60000);

    } else if (!wsOpened) {
      console.log('DISCONNECTED to WEBSOCKETS 1');
      setSocketsDisconnect(true);
    } else {
      console.log('DISCONNECTED to WEBSOCKETS 0');
      // reload page again
      

        // setTimeout(() => {
        //   console.log("DISCONNECTED to WEBSOCKETS 3");
        //   checkTimeSessionToken();
        //   reloadPage();

        // }, 6000);
  


    }
  }, [wsOpened]);

  useEffect(() => {
    if (wsDisconnected) {
      console.log("wsDisconnected", wsDisconnected);
      setTimeout(() => {
        setShowRefreshBtn(true);
    }, 10000);

    }
    
  }, [wsDisconnected]);


useEffect(() => {
    if (!wsOpened && errorDisplay) {
      
      // console.log("DISCONNECTED to WEBSOCKETS 3");
      checkTimeSessionToken();
      reloadPage();

    }
  }, [errorDisplay]);


  useEffect(() => {
    if (selectedGate) {
      console.log("selectedGate:", selectedGate);
      setLoadingInstruction({ status: false, data: null });
      setLoadingSelected(false);

      let abortDisplay = true;
      if (originalPushbackData && selectedGate) {
        //got new pushback data and driver already selected one gate then
        //refresh selected gate data based on new pushback dataset
        let updatedSelectedGate = originalPushbackData.filter(
          (e) => e.bay === selectedGate.bay
        );
        if (updatedSelectedGate.length > 0) {
          setGateNotExisting(false);
          console.log('updatedGate 1');
          if (selectedGate.bay !== updatedSelectedGate[0].bay) {
            setAbortFlagValue(false);
          }

          //Tracks the current status and check if previously modal has been close
          if (
            selectedGate.status == "M" &&
            updatedSelectedGate[0].status == "M" &&
            abortFlagValue == true
          ) {
            // abortDisplay = true;
            if (passConfirmation === true) {
              abortDisplay = true;
              // console.log("passConfirmation loading true", passConfirmation);
            } else {
              abortDisplay = false;
              // console.log("passConfirmation loading false", passConfirmation);
            }
          } else {
            abortDisplay = true;
            setAbortFlagValue(false);
          }
        } 

         
      }

      console.log("abortflag: ", abortFlagValue);
      // start remove this for the stop pushback
      // if (selectedGate.status === "M") {
      //   if (abortDisplay) {
      //     hiddenButton.current.click();
      //   }

      //   setShowMismatchPopup(abortDisplay);
      //   console.log("abortFlagDisplay1:", abortDisplay);
      // } else if (
      //   selectedGate.status === "A" &&
      //   selectedGate.prevstatus &&
      //   selectedGate.prevstatus != "M" &&
      //   selectedGate.prevstatus != "A"
      // ) {
      //   if (abortDisplay) {
      //     hiddenButton.current.click();
      //   }
      //   setShowMismatchPopup(abortDisplay);
      //   console.log("abortFlagDisplay3:", abortDisplay);
      // }
      // end remove this for the stop pushback

      // comment this out
      //get gate local storage
      // let existingGateStorage = window.localStorage.getItem("gateSelected");
      // existingGateStorage = existingGateStorage
      //   ? JSON.parse(existingGateStorage)
      //   : {};

      // // store updated selected gate
      // existingGateStorage = selectedGate;

      // //set selected gate if there is existing data in localstorage
      // setGateLocal(existingGateStorage);
      // window.localStorage.setItem(
      //   "gateSelected",
      //   JSON.stringify(existingGateStorage)
      // );

      // end comment
      
      // check if instruction is selected already
      if (selectedGate.status != "M" && selectedGate.status != "A" && selectedGate.status != "P") {
        if (selectedGate.app_pushback_instruction_1_class_name === 'driver-page-instruction-selected') {
          setSelectedInstruction(1);
        } else if (selectedGate.app_pushback_instruction_2_class_name === 'driver-page-instruction-selected') {
          setSelectedInstruction(2);
        } else if (selectedGate.app_pushback_instruction_3_class_name === 'driver-page-instruction-selected') {
          setSelectedInstruction(3);
        } 
      } else {
        setSelectedInstruction(0);
      }
      

      // addded for pop-up
      if (selectedGate.pushback_instruction_driver) {
        setInstructionSelected(selectedGate.pushback_instruction_driver);
        setBayInstructionSelected(selectedGate.bay);
      } else {
        setInstructionSelected('');
        // setBayInstructionSelected(selectedGate.bay);
      }

      if (selectedGate.previous_pushback_instruction_driver) {

        setPreviousPushback(selectedGate.previous_pushback_instruction_driver)

      }

      // console.log("STORE NEW GATE", selectedGate);
    }
  }, [selectedGate]);

  useEffect(() => {
    if (loadingInstruction.status) {
      // console.log("uupp loading", loadingInstruction.status);
      setLoadingSelected(true);
      sendInstruction(loadingInstruction.data);
    } else {
      setLoadingSelected(false);
    }
  }, [loadingInstruction]);
  
  useEffect(() => {
    if (prevInstructionSelected && instructionSelected) {
      console.log("uupp prevInstructionSelected", prevInstructionSelected);
    }
  }, [prevInstructionSelected, instructionSelected]);

  useEffect(() => {
    if (previousPushback) {
      console.log("uupp previousPushback", previousPushback);
    }
  }, [previousPushback]);

  useEffect(() => {
    if (loadingSelected) {
      console.log("uupp loadingSelected 111", loadingSelected);
    }
  }, [loadingSelected]);

  // preload images 
  useEffect(() => {
    if (selectedGate && pushbackMapping) {
      // console.log("pushbackMapping", pushbackMapping);

      // let arrayNew = [];

      let mappingData1 = pushbackMapping.data.filter((item) => { 
        return item.bay === selectedGate.bay; 
      }).map((e) => { 
        if (e.app_pushback_instruction_1_animation) {
          let app_pushback_instruction_1_animation_url = constants.MEDIA_PATH
           + e.app_pushback_instruction_1_animation + '.gif';
           return app_pushback_instruction_1_animation_url
          // arrayNew.push(app_pushback_instruction_1_animation_url);
        }
      });

      
      let mappingData2 = pushbackMapping.data.filter((item) => { 
        return item.bay === selectedGate.bay; 
      }).map((e) => { 
        if (e.app_pushback_instruction_2_animation) {
          let app_pushback_instruction_2_animation_url = constants.MEDIA_PATH
           + e.app_pushback_instruction_2_animation + '.gif';
           return app_pushback_instruction_2_animation_url
        }  
      });

      let mappingData3 = pushbackMapping.data.filter((item) => { 
        return item.bay === selectedGate.bay; 
      }).map((e) => { 
        if (e.app_pushback_instruction_3_animation) {
          let app_pushback_instruction_3_animation_url = constants.MEDIA_PATH
           + e.app_pushback_instruction_3_animation + '.gif';
           return app_pushback_instruction_3_animation_url
        }  
      });
      

      
      // let mappingData1 = pushbackMapping && pushbackMapping.data.map((e) => {
      //   if (e.app_pushback_instruction_1_animation) {
      //     let app_pushback_instruction_1_animation_url = constants.MEDIA_PATH
      //      + e.app_pushback_instruction_1_animation + '.gif';
      //      return app_pushback_instruction_1_animation_url
      //   } 
      // });
      

      // console.log('mappingData 1', mappingData1);
      // console.log('mappingData 2', arrayNew);
      // console.log('mappingData 2', mappingData2);
      // console.log('mappingData 3', mappingData3);

      let newMappingData = [...mappingData1, ...mappingData2, ...mappingData3];
      newMappingData = newMappingData.filter(element => element !== undefined);



      console.log('mappingData', newMappingData);

      setMappingData(newMappingData);

    }
  }, [selectedGate]);


  useEffect(() => {
    if (prevBayInstructionSelected && previousPushback && bayInstructionSelected && updateValidateData && !loadingSelected) {
      // console.log("uupp loadingSTatus", loadingInstruction.status);
      console.log("uupp baySelected 1", bayInstructionSelected);
      console.log("uupp prev bay", prevBayInstructionSelected);
      console.log("uupp loadingSelected", loadingSelected);
      console.log("uupp condition 1 1",  bayInstructionSelected === updateValidateData.current_parkingstand);
      console.log("uupp condition 1 1",  updateValidateData.previous_pushback_instruction_driver !== '');
      console.log("uupp condition 3 1",  previousPushback !== updateValidateData.pushback_instruction_driver);
      console.log("uupp condition 3 1",  previousPushback);
      console.log("uupp condition 3 1",  prevBayInstructionSelected);

      // if ((bayInstructionSelected === updateValidateData.current_parkingstand) && prevInstructionSelected !== '') {

        if (
          (bayInstructionSelected === updateValidateData.current_parkingstand) && 
          updateValidateData.previous_pushback_instruction_driver !== ''
          ) {
            console.log("uupp condition 1");
        // if (prevInstructionSelected !== '') {
          // if (prevBayInstructionSelected === bayInstructionSelected) {
          // if ((prevBayInstructionSelected === bayInstructionSelected)) {
          //   console.log("uupp condition 2");

            // if (
            //   bayInstructionSelected === updateValidateData.current_parkingstand &&
            //   previousPushback !== updateValidateData.pushback_instruction_driver
            //   ) {
            if (
              previousPushback !== updateValidateData.pushback_instruction_driver
              ) {
                console.log("uupp condition 3");
                console.log("uupp updateValidateData", updateValidateData);
                console.log("uupp previousPushback", previousPushback);
                console.log("uupp baySelected", bayInstructionSelected);
                
    
                console.log("uupp changed instruction");
                setShowInstructionMismatchPopup(true);
    
                } else {
                console.log("uupp not changed instruction")
                setShowInstructionMismatchPopup(false);
              }
    
  
          // }

          // }

          
      } 

      // if (
      //   bayInstructionSelected === updateValidateData.current_parkingstand && 
      //   // previousPushback !== updateValidateData.pushback_instruction_driver
      //   previousPushback !== updateValidateData.pushback_instruction_driver
      // ) {
      //   setShowInstructionMismatchPopup(true);
      //   console.log("uupp changed instruction");

      // }
      else {
        console.log("uupp different bay");
        // setShowInstructionMismatchPopup(true);
      }



    }
  }, [updateValidateData, previousPushback, bayInstructionSelected, loadingSelected, prevInstructionSelected]);



  useEffect(() => {
    if (gatesData) {
      let filteredGatesData = gatesData.filter((el) => {
        let limit = moment().add(constants.TIME_CAP, "minutes"); // current time plus 45mins
        // let startupapproval_datetime = moment(
        //   el.startupapproval_date + " " + el.startupapproval_time,
        //   "YYYY-MM-DD HH:mm"
        // );
        let targeted_offblock_datetime = "";

        if (el.targeted_offblock_date) {
          targeted_offblock_datetime = moment(
            el.targeted_offblock_date + " " + el.targeted_offblock_time,
            "YYYY-MM-DD HH:mm"
          );
        } else {
          targeted_offblock_datetime = moment(
            el.scheduled_date + " " + el.scheduled_time,
            "YYYY-MM-DD HH:mm"
          );
        }
  
        // console.log('e.parking_stand', el.current_parkingstand);
        // console.log('e.parking_stand', limit.diff(targeted_offblock_datetime, "minutes"));
        
        return (
          // el.delete_marker === "N" &&
          el.is_deleted === "False" &&
          // limit.diff(startupapproval_datetime, "minutes") >= 0
          limit.diff(targeted_offblock_datetime, "minutes") >= 0 &&
          // moment(limit).diff(moment(targeted_offblock_datetime), "minutes") >= 0 &&
          (!el.airborne_date && !el.airborne_time ||
          el.airborne_date === '' && el.airborne_time === '' )
        );
      });

      // console.log("limit filterGatesList", filteredGatesData);

      let pbdata = filteredGatesData.map((e) => {
        let pbrow = {};
        let airlineCodeDtls = airlineCodeMapping.data.filter(
          (a) => a.IATA == e.airline_code
        );
        pbrow.call_sign = e.flightno;
        pbrow.bay = e.current_parkingstand;
        if (e.startupapproval_time) {
          // console.log('e.startupapproval_time', e.startupapproval_time)
          // console.log('e.startupapproval_time 1',  e.startupapproval_time.substring(3, 5))
          // pbrow.startupapproval_time =
          //   e.startupapproval_time.substring(0, 2) +
          //   ":" +
          //   e.startupapproval_time.substring(2, 4);
          pbrow.startupapproval_time =
            e.startupapproval_time.substring(0, 2) +
            ":" +
            e.startupapproval_time.substring(3, 5);
        } else {
          pbrow.startupapproval_time = "";
        }
        if (e.targeted_offblock_time) {
          // let time = moment(e.targeted_offblock_time, 'HH:mm').subtract(30, 'minutes').format('HH:mm');
          // console.log("log", time);

          // pbrow.targeted_offblock_time = time;

          // pbrow.targeted_offblock_time =
          //   e.targeted_offblock_time.substring(0, 2) +
          //   ":" +
          //   e.targeted_offblock_time.substring(2, 4);
          pbrow.targeted_offblock_time =
            e.targeted_offblock_time.substring(0, 2) +
            ":" +
            e.targeted_offblock_time.substring(3, 5);
        } else if (e.startupapproval_time) {
          // let time = moment(e.startupapproval_time, 'HH:mm').subtract(30, 'minutes').format('HH:mm');
          // console.log("log", time);

          // pbrow.targeted_offblock_time = time;

          // pbrow.targeted_offblock_time =
          //   e.startupapproval_time.substring(0, 2) +
          //   ":" +
          //   e.startupapproval_time.substring(2, 4);
          pbrow.targeted_offblock_time =
            e.startupapproval_time.substring(0, 2) +
            ":" +
            e.startupapproval_time.substring(3, 5);
        } else {
          pbrow.targeted_offblock_time = "";
        }
        if (e.registration) {
          pbrow.registration = e.registration;
        } else {
          pbrow.registration = "";
        }
        if (e.aircraft_type) {
          pbrow.aircraft_type = e.aircraft_type;
        } else {
          pbrow.aircraft_type = "";
        }

        pbrow.status = "";
        pbrow.message_type = "";
        if (e.message_type) {
          pbrow.message_type = e.message_type;
        }

        //command from ATC
        pbrow.pushback_instruction_atc = "";
        if (e.pushback_instruction_atc) {
          pbrow.pushback_instruction_atc = e.pushback_instruction_atc;
        }

        //command from driver
        pbrow.pushback_instruction_driver = "";
        if (e.pushback_instruction_driver) {
          pbrow.pushback_instruction_driver = e.pushback_instruction_driver;
        }

        // previous selection of instruction
        pbrow.previous_pushback_instruction_driver = "";
        if (e.previous_pushback_instruction_driver) {
          pbrow.previous_pushback_instruction_driver = e.previous_pushback_instruction_driver;
        }

        //set instruction button text and css class name
        let pbinstructiondtls = pushbackMapping.data.filter(
          (i) => i.bay === e.current_parkingstand
        );
        // console.log('parrking_stand', pbinstructiondtls)
        if (pbinstructiondtls.length > 0) {
          pbrow.gmc = pbinstructiondtls[0].gmc;

          if (
            pbrow.pushback_instruction_atc === "ABORT" &&
            pbrow.pushback_instruction_driver === ""
          ) {
            pbrow.status = "A";
          } else if (
            !pbrow.pushback_instruction_driver &&
            pbrow.pushback_instruction_atc != "ABORT"
          ) {
            pbrow.status = "P";
          } else if (
            pbrow.pushback_instruction_driver &&
            pbrow.pushback_instruction_atc &&
            pbrow.pushback_instruction_atc != "ABORT" &&
            pbrow.pushback_instruction_driver != pbrow.pushback_instruction_atc
          ) {
            pbrow.status = "M";
          } else {
            pbrow.status = "D";
          }
          pbrow.app_pushback_instruction_1 =
            pbinstructiondtls[0].app_pushback_instruction_1;
          pbrow.app_pushback_instruction_2 =
            pbinstructiondtls[0].app_pushback_instruction_2;
          pbrow.app_pushback_instruction_3 =
            pbinstructiondtls[0].app_pushback_instruction_3;

          pbrow.app_pushback_instruction_1_animation =
            pbinstructiondtls[0].app_pushback_instruction_1_animation;
          pbrow.app_pushback_instruction_2_animation =
            pbinstructiondtls[0].app_pushback_instruction_2_animation;
          pbrow.app_pushback_instruction_3_animation =
            pbinstructiondtls[0].app_pushback_instruction_3_animation;

          pbrow.app_pushback_instruction_1_class_name =
            "driver-page-instruction-default";
          pbrow.app_pushback_instruction_2_class_name =
            "driver-page-instruction-default";
          pbrow.app_pushback_instruction_3_class_name =
            "driver-page-instruction-default";

          if (pbrow.status != "M" && pbrow.status != "A" && pbrow.status != "P") {
            if (
              pbrow.app_pushback_instruction_1 ===
              pbrow.pushback_instruction_driver
            ) {
              pbrow.app_pushback_instruction_1_class_name =
                "driver-page-instruction-selected";
              //disabled
              // pbrow.app_pushback_instruction_2_class_name =
              //   "driver-page-instruction-disabled";
              // pbrow.app_pushback_instruction_3_class_name =
              //   "driver-page-instruction-disabled";
            }

            if (
              pbrow.app_pushback_instruction_2 ===
              pbrow.pushback_instruction_driver
            ) {
              pbrow.app_pushback_instruction_2_class_name =
                "driver-page-instruction-selected";
              //disabled
              // pbrow.app_pushback_instruction_1_class_name =
              //   "driver-page-instruction-disabled";
              // pbrow.app_pushback_instruction_3_class_name =
              //   "driver-page-instruction-disabled";
            }

            if (
              pbrow.app_pushback_instruction_3 ===
              pbrow.pushback_instruction_driver
            ) {
              pbrow.app_pushback_instruction_3_class_name =
                "driver-page-instruction-selected";
              //disabled
              // pbrow.app_pushback_instruction_1_class_name =
              //   "driver-page-instruction-disabled";
              // pbrow.app_pushback_instruction_2_class_name =
              //   "driver-page-instruction-disabled";
            }
            
          }

          pbrow.lat = pbinstructiondtls[0].north_lat_decimal_format;
          pbrow.long = pbinstructiondtls[0].east_long_decimal_format;
        }

        pbrow.searchstr = (pbrow.call_sign + pbrow.bay).toLowerCase();
        pbrow.sortkey_tsat = e.startupapproval_date + e.startupapproval_time;
        return pbrow;
      });

      let sortedpbdata = sortByKey(pbdata, "bay", false, true);
      // console.log("sortedpbdata", sortedpbdata);
      setOriginalPushbackData(sortedpbdata);
      setLoading(false);
    }
  }, [gatesData, refetch]);

  // useEffect(() => {
  //   if (loadingInstruction.status) {
  //     sendInstruction(loadingInstruction.data);
  //   }
  // }, [loadingInstruction]);

  // useEffect(() => {
  //   if (showAirplaneRoute) {
  //     console.log("airport showAirplaneRoute", showAirplaneRoute.filePath);
  //   }
  // }, [showAirplaneRoute]);

  // useEffect(() => {
  //   if (prevAirportRoute && showAirplaneRoute) {
  //     console.log("airport prevAirportRoute", prevAirportRoute);
  //     console.log("airport prevAirportRoute 2", prevAirportRoute.filePath);
  //     console.log("airport prevAirportRoute 3", prevAirportRoute.filePath !== showAirplaneRoute.filePath);
  //   }
  // }, [prevAirportRoute, showAirplaneRoute]);

  
  // check internet connection
  useEffect(() => {
    setInterval(() => {
      var condition = navigator.onLine ? "online" : "offline";
      // console.log('NAVIGATOR ONLINE', navigator.onLine);
      if (condition === "online") {
        setCheckConnection(false);
      } else {
        console.log("OFFLINE");
        setCheckConnection(true);
      }
    }, 60000);
  }, []);

  // check user token validity
  useEffect(() => {
    // console.log("TTime SESSION New");
    checkTimeSessionToken();

    setInterval(() => {
      checkTimeSessionToken();
      reloadPage();
    // }, 2700000); //2700000 this will check every 45mins
    }, 2700000); //1800000 this will check every 30mins
  }, []);

   // SWEET 
  useEffect(() => {
    setInterval(() => {

      // SWEET
      const getSessionId = window.localStorage.getItem("driverSessionId");

      if (getSessionId) {
        console.log('sessionInfo every 30mins', getSessionId);
        // setTimeout(() => {
        //   dispatch(getSessionInfo({session_id: getSessionId}));
        // }, 1000);
        reloadPage();
      }

    // }, 2700000); //2700000 this will check every 45mins
    // }, //300000 this will check every 5mins
    }, 1800000); //1800000 this will check every 30mins
  }, []);

  // check idle state if animation modal is clicked
  useEffect(() => {
    checkTimeSessionToken();
    
    if (idleState === 'Idle') {
      console.log("TTime SESSION New");
      console.log("Idle", idleState);

    checkTimeSessionToken();
    setTimeout(() => {
      checkTimeSessionToken();
      reloadPage();
    }, 500); 

    // SWEET
    const getSessionId = window.localStorage.getItem("driverSessionId");

    if (getSessionId) {
      // setTimeout(() => {
      //   dispatch(getSessionInfo({session_id: getSessionId}));
      // }, 1000);
      reloadPage();
      console.log('sessionInfo 2', getSessionId);
    }
    
    } else {
      console.log("Idle Not", idleState);
      console.log('Idle time', moment().format('DD MMMM YYYY, HH:mm:ss'));
    }
    
  }, [idleState]);

  useEffect(() => {

    if (showAirplaneRoute.flag) {
      handlePauseTimer();
      console.log('session not running');
      // const interval = setInterval(() => {
      //   checkTimeSessionToken();
      //   reloadPage();
      // // }, 2700000); //2700000 this will check every 45mins
      // }, 300000); //300000 this will check every 5mins

      // return () => clearInterval(interval);
    } else {
      console.log('session running')
      handleResumeTimer()
      let timeNow = moment();

      if (!wsOpened && errorDisplay) {
        console.log('DISCONNECTED to WEBSOCKETS 2');
        checkTimeSessionToken();
        reloadPage();
      }

      // check if timeModalOpen has value
      if (timeModalOpen) {
        console.log('five value 1', timeModalOpen)
        console.log('five value 2', timeNow)

        if (timeNow.diff(timeModalOpen, 'minutes') >= 0.5) {
          console.log('five greater')
          checkTimeSessionToken();
          reloadPage();
        } else {
          console.log('five less')
        }
      }

      if (errorSessionDisplay) {
        console.log('DISCONNECTED to WEBSOCKETS 3');
        checkTimeSessionToken();
        reloadPage();
      }
     
    }
  }, [showAirplaneRoute.flag]);

  // idleTimer functions
  const onIdle = () => {
    console.log('Timer User has been idle for too long!');
    // get new session
    setIdleState('Idle');
  }

  const handleResumeTimer = () => {
    // idleTimerRef.current.resume();
    resume();
    setIdleState('Active');
    console.log('Timer resume!');
  }

  const handlePauseTimer = () => {
    // idleTimerRef.current.pause();
    pause();
    setIdleState('Pause');
    console.log('Timer paused!');
    let timeOpen = moment();
    setTimeModalOpen(timeOpen);
  }

  const { getRemainingTime, resume, pause } = useIdleTimer({
    onIdle,
    // timeout: 900_000,
    // timeout: 300_000,
    timeout: 30_000,
    // timeout: 60_000,
    throttle: 500
  })


  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000))
    }, 500)
    console.log('timer', getRemainingTime())
    console.log('timer2', Math.ceil(getRemainingTime() / 1000));
    return () => {
      clearInterval(interval)
    }
  }, []);


  useEffect(() => {
    if (errorSessionDisplay) {
      // let access_token = userLocal ? userLocal.accessToken.jwtToken : '';

      // getWay2GoUser(access_token);
      // setTimeout(() => {
      //   checkUserTokenValidity();
      // }, 2000);

      checkUserTokenValidity();
      setTimeout(() => {
        checkUserTokenValidity();
        reloadPage();
      }, 180000);
    }
  }, []);

  useEffect(() => {
    if (sessionInfo) {
      console.log('sessionInfo', sessionInfo);
    }
  }, [sessionInfo]);

  useEffect(() => {
    if (sessionInfo && sessionInfo.status === 'error') {
      console.log('sessionInfo error', sessionInfo);
      logoutUser();
    }
  }, [sessionInfo]);


  useEffect(() => {
    if (mappingData) {
      console.log('mappingData', mappingData);
    }
  }, [mappingData]);

  // useEffect(() => {
  //   if (mappingData) {
  //     const preloadImages = () => {
  //       const imagePromises = mappingData.map((imageUrl) => {
  //         console.log('mappingData 1')
  //         return new Promise((resolve, reject) => {
  //           const img = new Image();
  //           img.src = imageUrl;
  //           img.onload = resolve;
  //           img.onerror = reject;
  //         });
  //       });
  
  //       Promise.all(imagePromises)
  //         .then(() => {
  //           console.log('mappingData Images preloaded and cached.');
  //         })
  //         .catch((error) => {
  //           console.error('mappingData Failed to preload and cache images:', error);
  //         });
  //     };
  //     preloadImages();
  //   }
    

    
  // }, [mappingData]); // Empty dependency array ensures this runs only once on component mount


  const checkUserTokenValidity = () => {
    // call refresh token
    let poolData = {
      UserPoolId: constants.USERPOOLID,
      ClientId: constants.CLIENTID,
    };
    let userPool = new CognitoUserPool(poolData);
    // console.log('TTTime userpool', userPool)

    // NON SWEET FLOW
    const cognitoUser = userPool.getCurrentUser();
    // console.log("TTTime cognitoUser", cognitoUser);

    
    // NON SWEET FLOW
    if (
      cognitoUser &&
      cognitoUser.username === userLocal.idToken.payload["cognito:username"] &&
      userLocal.idToken.payload["custom:role"] === "driver"
    ) {
      // console.log("TTTime cognitoDRIVER 1");
      // console.log("TTTime cognitoDRIVER 2");
      // console.log("TTTime same driver user");

      cognitoUser.getSession(function (err, data) {
        if (err) {
          // Prompt the user to reauthenticate by hand...
          props.history.push("/");
        } else {
          const cognitoUserSession = data;
          const yourAccessToken = cognitoUserSession.getAccessToken().jwtToken;
          // const yourIdToken = cognitoUserSession.getIdToken().jwtToken;
          let refresh_token = cognitoUserSession.getRefreshToken();

          // setup AWS config
          AWS.config.credentials = new AWS.CognitoIdentityCredentials(
            {
              IdentityPoolId: "",
              Logins: {
                [constants.LOGINS]: yourAccessToken,
              },
            },
            {
              region: "ap-southeast-1",
            }
          );
          if (AWS.config.credentials.needsRefresh()) {
            cognitoUser.refreshSession(
              refresh_token,
              (refErr, cognitoUserSession) => {
                //this provide new accessToken, IdToken, refreshToken
                // you can add you code here once you get new accessToken, IdToken, refreshToken
                if (refErr) {
                  // throw refErr;
                  console.log("TTime error", refErr);
                } else {
                  // console.log("TTime NEW SESSION", cognitoUserSession);
                  AWS.config.credentials.params.Logins[
                    constants.LOGINS
                  ] = cognitoUserSession.getAccessToken().jwtToken;

                  // // //get existing local storage
                  let existingLocalStorage = window.localStorage.getItem(
                    "driverToken"
                  );
                  // let existingLocalStorage = sessionStorage.getItem('driverSession');
                  let accessTokenLocalStorage = localStorage.getItem(
                    "driverAccessToken"
                  );

                  // If no existing data, create an array
                  // Otherwise, convert the localStorage string to an array
                  existingLocalStorage = existingLocalStorage
                    ? JSON.parse(existingLocalStorage)
                    : {};
                  accessTokenLocalStorage = accessTokenLocalStorage
                    ? accessTokenLocalStorage
                    : "";

                  // store new session in localStorage
                  existingLocalStorage = cognitoUserSession;
                  accessTokenLocalStorage = cognitoUserSession.getAccessToken()
                    .jwtToken;

                  // Save back to localStorage
                  setUserLocal(existingLocalStorage);
                  localStorage.setItem(
                    "driverToken",
                    JSON.stringify(existingLocalStorage)
                  );
                  // sessionStorage.setItem('driverSession', JSON.stringify(existingLocalStorage));
                  localStorage.setItem(
                    "driverAccessToken",
                    accessTokenLocalStorage
                  );

                  // add new session to the store
                  dispatch(updateUser(cognitoUserSession));
                  // console.log("TTIME updated the json and user");
                  // console.log("TTIME UPDATED LOCAL STORAGE FROM NEW SESSION", cognitoUserSession);
                  // console.log("TTIME UPDATED LOCAL STORAGE FROM NEW SESSION2", userLocal);
                  console.log("TTIME TODAY", moment().format("HH:mm:ss"));
                  console.log(
                    "TTIME UNIX",
                    moment
                      .unix(userLocal.idToken.payload.exp)
                      .format("MMMM Do YYYY hh:mm:ss A")
                  );
                  // console.log("TTIME NEW ACCESS TOKEN", cognitoUserSession.getAccessToken().jwtToken);

                  // console.log("TTTime AWS.config.credentials", AWS.config.credentials);
                  // AWS.config.credentials.refresh(err => {
                  //   if (err) {
                  //     console.log(err);
                  //   } else {
                  //     console.log('TTIME TOKEN SUCCESSFULLY UPDATED');
                  //   }
                  // });
                }
              }
            );
          }
        }
      });
    }
  };

  const doesAnimationExist = urlToFile => {
    
    var xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        setLoadingImg(false);
        console.log('file loaded');
      } else {
        setLoadingImg(true);
        console.log('file not loaded');
      }
    };

   
    xhr.open("GET", urlToFile, true);

    xhr.send();

    if (xhr.status == "404") {
      console.log("File doesn't exist");
      // setLoadingImg(false);
      // setLoading(false);
      return false;
    } else {
      console.log("File exists");
      // setLoading(false);
      // setLoadingImg(false);
      return true;
    }
    // setLoading(true);
  
   

  
  };

  //check time interval function
  const checkTimeSessionToken = () => {
    let today = moment().unix();
    let expirationTime = moment
      .unix(userLocal.idToken.payload.exp);
    // let access_token = userLocal ? userLocal.accessToken.jwtToken : '';

    if (today < expirationTime) {
      // console.log("TTIME THERE IS NO TIME LEFT");
      // getWay2GoUser(access_token);
      // setTimeout(() => {
      //   checkUserTokenValidity();
      // }, 2000);
      checkUserTokenValidity();
    } else {
      console.log("TIME THERE IS TIME LEFT");
      setErrorSessionDisplay(true);
      // logoutUser();
    }
  };

  const reloadPage = () => {
    window.location.reload();
  };

  const sendInstruction = (data) => {
    if (previousIntervalID) {
      clearInterval(previousIntervalID);
    }
    var elem = progressDiv.current;
    var width = 1;
    var id = setInterval(frame, 15);
    setPreviousIntervalID(id);
    function frame() {
      if (width >= 100) {
        console.log("sending instruction data:", data);
        // dispatch(wsSend(data));
        clearInterval(id);
      } else {
        width++;
        elem.style.width = width + "%";
      }
    }
  };

  const setGPSasLocation = () => {
    console.log("sortedGPSValue");
    console.log(sortedGPSValue);
  };

  const showConfirmationModal = (bay, instruction) => {
    setShowConfirmationPushbackPopup(true);
    setconfirmationInstruction({ bay: bay, instruction: instruction });
  };

  const showExistingInstructionModal = (bay, instruction) => {
    setShowExistingPushbackPopup(true);
    setconfirmationInstruction({ bay: bay, instruction: instruction });
  };

  const logoutUser = () => {
    dispatch(wsDisconnect()); //disconnect websocket
    dispatch(updateUser(null)); //logout -> clear user data
    window.localStorage.removeItem("driverAccessToken");
    window.localStorage.removeItem("driverToken");
    // sessionStorage.removeItem('driverSession');
    window.localStorage.removeItem("gateSelected");
    window.localStorage.removeItem("switchData");
    window.localStorage.removeItem("driverSessionId");
    props.history.push("/");
  };

  const rotateImageClockwise = () => {
    let rotation = rotateClockwiseValue;
    rotation += 90; // add 90 degrees, you can change this as you want
    if (rotation === 360) { 
      // 360 means rotate back to 0
      rotation = 0;
    }
    setRotateClockwiseValue(rotation);
    /* setGPSasLocation(); */
    console.log("rotation", rotation)
  }

  const rotateImageCounterClockwise = () => {
    let rotation = rotateClockwiseValue;
    rotation -= 90; // add 90 degrees, you can change this as you want
    if (rotation === -360) { 
      // 360 means rotate back to 0
      rotation = 0;
    }
    setRotateClockwiseValue(rotation);
    console.log("rotation", rotation)
  }

  const ImageCache = ({ imageUrls }) => {
    console.log('mappingData cache images start');
    const [preloadingComplete, setPreloadingComplete] = useState(false);
    useEffect(() => {
      const cacheImages = async () => {
        if (preloadingComplete) {
          console.log('mappingData Images already preloaded. Skipping preloading process.');
          return;
        }

        const imagePromises = imageUrls.map((url) => {
          return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.onload = resolve;
            img.onerror = reject;
          });
        });
  
        // await Promise.all(imagePromises); //  working
        try {
          await Promise.all(imagePromises);
          console.log('mappingData Images preloaded and cached.');
          setPreloadingComplete(true);
        } catch (error) {
          console.error('mappingData Failed to preload and cache images:', error);
        }
      };
  
      cacheImages();
    }, [imageUrls]);
  
    // return null;
    if (preloadingComplete) {
    return (
      <div>
        {/* Your React application content */}
        <h1>Your Application</h1>
        {/* Add the rest of your application components here */}
      </div>
    );
  } else {
    return (
      <div>
        {/* Loading indicator or other content while preloading */}
        <p>Loading...</p>
      </div>
    );
  }
  };

  return (
    <React.Fragment>
      {/* caching of images */}
      {/* {selectedGate && mappingData && (
        <ImageCache imageUrls={mappingData} />
      )} */}
      <audio ref={popupAudio}>
        <source src={audio_alerm_clock} type="audio/mpeg" />
      </audio>
      {/* {!wsOpened && (
        <div className="alert_notice">
          <Alert
            message="Retrieving latest flight and pushback data. Please reload the page if it failed to retrieve latest flights."
            type="error"
            className="alert_error"
          />
        </div>
      )} */}
      {/* {wsDisconnected && !showAirplaneRoute.flag && (
        <div className="alert_notice">
          <Alert
            message="Retrieving latest flight and pushback data. Please reload the page if it failed to retrieve latest flights."
            type="error"
            className="alert_error"
          />
        </div>
      )} */}
      {/* {wsOpened ? (
        <div className="alert_notice">
        <Alert
          message="Retrieving latest flight and pushback data. Please reload the page if it failed to retrieve latest flights."
          type="error"
          className="alert_error"
        />
      </div>
      ) : !wsOpened && errorDisplay ? (
        <div className="alert_notice">
          <Alert message="Error retrieving latest flight and pushback data. Please reload the page and try again." type="error" className="alert_error" />
        </div>
      ) : (
            <span />
          )} */}

    {/* {!wsOpened && errorDisplay ? (
        <div className="alert_notice">
          <Alert message="Error retrieving latest flight and pushback data. Please reload the page and try again." type="error" className="alert_error" />
        </div>
      ) : (
            <span />
          )} */}

      {/* {(!wsOpened && errorDisplay) && (
        <div className="alert_notice">
          <Alert message="Error retrieving latest flight and pushback data. Please reload the page and try again." type="error" className="alert_error" />
        </div>
      )} */}
      {errorSessionDisplay && (
        <div className="alert_notice">
          <Alert
            message="Session is almost over. Please reload the page to start new session."
            type="error"
            className="alert_error"
          />
        </div>
      )}
      {/* display offline message (if internet gets disconnected) */}
      {checkConnection && (
        <div className="alert_notice">
          <Alert
            message="Error retrieving latest flight and pushback data. Check internet connection and try again."
            type="error"
            className="alert_error"
          />
        </div>
      )}
      {/* **** */}
      <div className="Appbar">
        <Row type="flex" justify="start" align="middle">
          <Col>
            <Button type="link" style={{ color: `${variables.appColor}` }}>
              <img
                src={icon_user}
                alt="icon_user"
                style={{
                  marginRight: 10,
                  position: "relative",
                  top: -2,
                  width: "15px",
                }}
              />
              {user
                ? user.idToken.payload.name
                : userLocal.idToken.payload.name}
            </Button>

            <Divider type="vertical" style={styles.divider} />
            <Button
              type="link"
              style={{ color: `${variables.appColor}`, padding: 0 }}
              onClick={() => {
                setShowInformationPopup(true); //show modal for information
              }}
            >
              <img
                src={icon_info}
                alt="icon_info"
                style={{
                  marginRight: 5,
                  position: "relative",
                  top: "-2px",
                  width: "15px",
                }}
              />
              Information
            </Button>

            <Divider type="vertical" style={styles.divider} />
            <Button
              type="link"
              style={{ color: `${variables.appColor}`, padding: 0 }}
              onClick={logoutUser}
            >
              Log Out
            </Button>
          </Col>
        </Row>
      </div>
      <div style={styles.container}>
        <Spin size="large" spinning={loading}>

          {/* refresh icon here */}

            {/* <Row type="flex" justify="center" style={{ marginTop: "1em" }}>
              <Row
                type="flex"
                justify="start"
                align="middle"
                style={{
                  width: "100%",
                  lineHeight: "1em",
                }}
              >
                <Button 
                  shape="round" 
                  icon={<img src={icon_refresh} alt="icon_refresh" style={{ 
                    width: 15, 
                    marginRight: 10,
                    }} 
                  />} 
                  className="driver-page-refresh-btn"
                >
                  Click to retrieve latest flights
              </Button>
              </Row>
            </Row> */}
            
           {/* end refresh icon here */}

          <Card style={styles.card}>
            <Row type="flex" align="middle">
              <Col span={8}>
                <Row style={styles.rowHeader} justify="center">
                  FLIGHT
                </Row>
                {selectedGate ? (
                  <Row style={styles.row} justify="center">
                    {selectedGate.call_sign}
                  </Row>
                ) : (
                  <Row style={styles.row}>&nbsp;</Row>
                )}
              </Col>
              {/* <Col span={5}>
                <Row style={styles.rowHeader} justify="center">
                  REG NO.
                </Row>
                {selectedGate ? (
                  <Row style={styles.row} justify="center">
                    {selectedGate.registration}
                  </Row>
                ) : (
                  <Row style={styles.row}>&nbsp;</Row>
                )}
              </Col>*/}
              {/* <Col span={2}>
                <div style={{ textAlign: "center" }}>
                  <Divider
                    type="vertical"
                    style={{ background: "#9DA2A8", height: 20 }}
                  />
                </div>
              </Col>  */}
              <Col span={8}>
                <Row style={styles.rowHeader} justify="center">
                  TOBT
                </Row>
                {selectedGate ? (
                  <Row style={styles.row} justify="center">
                    {selectedGate.targeted_offblock_time}
                  </Row>
                ) : (
                  <Row style={styles.row}>&nbsp;</Row>
                )}
              </Col>
              {/* <Col span={2}>
                <div style={{ textAlign: "center" }}>
                  <Divider
                    type="vertical"
                    style={{ background: "#9DA2A8", height: 20 }}
                  />
                </div>
              </Col>  */}
              <Col span={8}>
                <Row style={styles.rowHeader} justify="center">
                  AIRCRAFT
                </Row>
                {selectedGate ? (
                  <Row style={styles.row} justify="center">
                    {selectedGate.aircraft_type}
                  </Row>
                ) : (
                  <Row style={styles.row}>&nbsp;</Row>
                )}
              </Col>
            </Row>
            <Row type="flex" justify="center" style={{ marginTop: "2em" }}>
              <Row type="flex" align="middle" style={styles.baySelect}>
                <Col
                  span={20}
                  onClick={() => {
                    // if (navigator.geolocation && originalPushbackData) {
                    //   setLoading(true);
                    //   navigator.geolocation.getCurrentPosition((location) => {
                    //     if (location) {
                    //       console.log("current location", location);
                    //       let gatesDistanceData = originalPushbackData.map(
                    //         (row) => {
                    //           row.distance = getDistanceFromLatLonInKm(
                    //             row.lat,
                    //             row.long,
                    //             location.coords.latitude,
                    //             location.coords.longitude
                    //           );
                    //           return row;
                    //         }
                    //       );

                    //       let sortedList = sortByKey(
                    //         gatesDistanceData,
                    //         "distance"
                    //       );
                    //       console.log("sortedByDistanceList:", sortedList);
                    //       if (sortedList.length > 3) {
                    //         setActiveGateListByDistance(sortedList.slice(0, 3));
                    //       } else {
                    //         setActiveGateListByDistance(sortedList);
                    //       }
                    //       setDisplayGateList(true);
                    //     }
                    //     setLoading(false);
                    //   });
                    // }
                    if (originalPushbackData) {
                      setDisplayGateList(true);
                    }
                    
                  }}

                >
                  <Row>
                    <Col
                      span={24}
                      offset={2}
                      style={{ paddingLeft: "2px", color: '#fff' }}
                    >
                      {/* {selectedGate && <b>{selectedGate.bay}</b>} */}
                      {selectedGate && <span style={{ fontSize: 20, fontWeight: 800 }}>{selectedGate.bay}</span>}
                      {!selectedGate && <span  style={{ fontSize: 18, fontWeight: 800 }}>Select a bay</span>}
                    </Col>
                  </Row>
                </Col>
                {/* <Col span={4}>
                  <img
                    src={icon_location}
                    alt="icon_location"
                    style={{ width: 45 }}
                    onClick={() => {
                      if (navigator.geolocation && originalPushbackData) {
                        setLoading(true);
                        navigator.geolocation.getCurrentPosition((location) => {
                          if (location) {
                            console.log("current location", location);
                            let gatesDistanceData = originalPushbackData.map(
                              (row) => {
                                row.distance = getDistanceFromLatLonInKm(
                                  row.lat,
                                  row.long,
                                  location.coords.latitude,
                                  location.coords.longitude
                                );
                                return row;
                              }
                            );

                            let sortedList = sortByKey(
                              gatesDistanceData,
                              "distance"
                            );
                            console.log("sortedByDistanceList:", sortedList);
                            setGpsDisplay(true);
                            setGpsSelectedBay(sortedList[0].bay);
                            setSortedGPSValue(sortedList);
                            //displayGPSModal(sortedList); // Pass the location computed by the gatesDistanceData
                          }
                          setLoading(false);
                        });
                      }
                    }}
                  />
                </Col> */}
                 <Col span={4}>
                  <img
                    src={arrow_dropdown}
                    alt="arrow_dropdown"
                    style={{ width: 20 }}
                    onClick={() => {
                      if (originalPushbackData) {
                        setDisplayGateList(true);
                      }
                    }}
                  />
                </Col>
              </Row>
            </Row>
            {/* <h1>React Idle Timer</h1>
              <h2>useIdleTimer</h2>
              <br /> */}
              {/* <p>{remaining} seconds remaining</p>
              <p>STATE: {idleState}</p> 
              <button onClick={handleResumeTimer}>Start Timer</button>
              <button onClick={handlePauseTimer}>Pause Timer</button>  */}
            <Row justify="center" align="center" style={{ marginTop: 15 }}>
              <Col>
                  <p style={{ textAlign: 'center' }}>
                    Only stands with live departure in the next 45 min to be shown here. 
                  </p>
                  
              </Col>
            </Row>

            {/* refresh icon here */}
            {/* {wsDisconnected && showRefreshBtn && (
              <Row type="flex" justify="center" style={{ marginBottom: '1em' }}>
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    width: "100%",
                    lineHeight: "1em",
                  }}
                >
                  <Button 
                    shape="round" 
                    icon={<img src={icon_refresh} alt="icon_refresh" style={{ 
                      width: 15, 
                      marginRight: 10,
                      }} 
                    />} 
                    className="driver-page-refresh-btn"
                    onClick={() => {
                      console.log("clicked refresh btn:");
                      reloadPage();
                      checkTimeSessionToken();
                    }}
                  >
                    Click to retrieve latest flights
                </Button>
                </Row>
              </Row>
            )} */}
            
            
             {/* end refresh icon here */}
             
            {gateNotExisting && (
              <Row justify="center" align="center" style={{ marginBottom: '10px' }}>
              <Col>
                  <p style={{ textAlign: 'center', color: '#ee252f' }}>
                   The Flight at {selectedGate.bay} has been moved/cancelled. Please check with your ops control for the latest info.
                  </p>
                  
              </Col>
            </Row>
            )}

            {getUpdateDataTime && (
               <Row justify="center" align="center" >
                <Col>
                    <p style={{ textAlign: 'center', fontSize: '.9em', color: '#1C60E5'}}>
                      Last update at {moment(getUpdateDataTime).format('DD MMMM YYYY, HH:mm')}
                    </p>
                    
                </Col>
             </Row>
             )}
            
          </Card>
          <Card style={styles.card1}>
            {!loadingInstruction.status && (
              <Row type="flex" justify="center">
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    width: 300,
                    height: 48,
                    borderRadius: 20,
                    overflow: "hidden",
                  }}
                >
                  {/* {!selectedGate && (
                    <Row
                      type="flex"
                      justify="start"
                      align="middle"
                      style={{
                        width: "100%",
                        height: 48,
                        background: "#1C60E6",
                        color: "#fff",
                        paddingLeft: 15,
                        lineHeight: "1em",
                      }}
                    >
                      <Col span={3}>
                        <img src={icon_anchor1} alt="icon_anchor1" />
                      </Col>

                      <Col span={21}>Select a bay</Col>
                    </Row>
                  )} */}

                  {selectedGate && selectedGate.status === "P" && (
                    <Row
                      type="flex"
                      justify="start"
                      align="middle"
                      style={{
                        width: "100%",
                        height: 48,
                        background: "#1C60E6",
                        color: "#fff",
                        paddingLeft: 15,
                        lineHeight: "1em",
                      }}
                    >
                      <Col span={3}>
                        <img src={icon_hand} alt="icon_hand" />
                      </Col>
                      <Col span={21}>
                        <b>Wait</b> for instruction
                        <br />
                        Then <b>select</b> pushback
                      </Col>
                    </Row>
                  )}

                  {selectedGate &&
                    (selectedGate.status === "M" ||
                      selectedGate.status === "A") && (
                      <Row
                        type="flex"
                        justify="start"
                        align="middle"
                        style={{
                          width: "100%",
                          height: 48,
                          background: "#1C60E6",
                          color: "#fff",
                          paddingLeft: 15,
                          lineHeight: "1em",
                        }}
                      >
                        <Col span={3}>
                          <img src={icon_hand} alt="icon_hand" />
                        </Col>
                        <Col span={21}>
                          <b>Wait</b> for instruction
                          <br />
                          Then <b>select</b> pushback
                        </Col>
                      </Row>
                    )}

                  {selectedGate && selectedGate.status === "D" && (
                    <Row
                      type="flex"
                      justify="start"
                      align="middle"
                      className="driver-success-status"
                    >
                      <Col span={3}>
                        <img src={icon_check} alt="icon_check" />
                      </Col>
                      <Col span={21}>
                        <b>Pushback selected</b>
                        <br />
                        Start Pushback
                      </Col>
                    </Row>
                  )}
                </Row>
              </Row>
            )}

            {loadingInstruction.status && (
              <Row type="flex" justify="center">
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    width: 300,
                    height: 48,
                    borderRadius: 20,
                    border: "2px solid rgba(28, 96, 230, 0.5)",
                    overflow: "hidden",
                  }}
                >
                  <div
                    ref={progressDiv}
                    style={{
                      width: "8%",
                      height: 48,
                      background: "rgba(28, 96, 230, 0.5)",
                      color: "#fff",
                      paddingLeft: 15,
                      lineHeight: "1em",
                    }}
                  ></div>
                </Row>
              </Row>
            )}

            {selectedGate && (
              <div
                style={{
                  marginTop: "1em",
                  maxWidth: 300,
                  marginRight: "auto",
                  marginLeft: "auto",
                }}
              >
                {selectedGate.app_pushback_instruction_1 && (
                  <Row
                    type="flex"
                    align="middle"
                    style={{ marginTop: "1em" }}
                    // className={
                    //   selectedGate.app_pushback_instruction_1_class_name
                    // }
                    onMouseDown={(e) => e.target.classList.add("pressed")}
                    onMouseUp={(e) => e.target.classList.remove("pressed")}
                    onTouchStart={(e) => e.target.classList.add("pressed")}
                    onTouchEnd={(e) => e.target.classList.remove("pressed")}
                  >
                    <Col
                      className="driver-page-icon-default"
                      style={{ marginTop: -5 }}
                      xs={5}
                      sm={5}
                      md={4}
                      lg={4}
                      xl={4}
                      onClick={() => {
                        // setLoadingImg(true);
                        console.log("clicked instruction1:", showAirplaneRoute);
                        // trigger the loading spinner
                        let filePath =
                          constants.MEDIA_PATH +
                          selectedGate.app_pushback_instruction_1_animation +
                          ".gif";
                        // let filePath = static_image;
                        if (doesFileExist(filePath)) {
                          console.log("airport file 1", doesFileExist(filePath));
                          setShowAirplaneRoute({
                            flag: true,
                            filePath: filePath,
                          });
                          setShowAirplaneRouteModal(true);
                          // setLoadingImg(false);
                        } else {
                          filePath =
                            constants.MEDIA_PATH +
                            selectedGate.app_pushback_instruction_1_animation +
                            ".pdf";

                          if (doesFileExist(filePath)) {
                            // setLoadingImg(false);
                            console.log("airport file 1", doesFileExist(filePath));
                            window.open(filePath);
                          }
                        }
                      }}
                    >
                      <img src={info_icon} alt="info_icon" />
                    </Col>
                    <Col span={2}></Col>
                    <Col
                      xs={17}
                      sm={17}
                      md={18}
                      lg={18}
                      xl={18}
                      // className={
                      //   selectedGate.app_pushback_instruction_1_class_name
                      // }
                      // onClick={(e) => {
                      //   showConfirmationModal(selectedGate.bay, selectedGate.app_pushback_instruction_1);
                      // }}
                    >
                      <Button
                        className={`${
                          selectedGate.app_pushback_instruction_1_class_name
                        } ${
                          loadingInstruction.status &&
                          selectedClass ===
                            selectedGate.app_pushback_instruction_1
                            ? "driver-page-instruction-loading-selected"
                            : ""
                        }`}
                        onClick={() => {
                          if (selectedInstruction !== 0) {
                            showExistingInstructionModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_1
                            );
                          } else {
                            showConfirmationModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_1
                            ); //show modal for information
                          }
                          
                        }}
                        // disabled={
                        //   (selectedGate.app_pushback_instruction_1_class_name ===
                        //     "driver-page-instruction-disabled" &&
                        //     selectedGate.status !== "P") ||
                        //   loadingInstruction.status ||
                        //   selectedGate.app_pushback_instruction_1_class_name ===
                        //     "driver-page-instruction-selected" ||
                        //   selectedGate.status === "M"
                        // }
                      >
                        {/* {selectedGate.app_pushback_instruction_1} */}
                        <span
                          className={`${
                            selectedGate.app_pushback_instruction_1.length >= 18
                              ? "long_text_driver"
                              : ""
                          }`}
                        >
                          {selectedGate.app_pushback_instruction_1}
                        </span>
                      </Button>
                    </Col>
                  </Row>
                )}

                {selectedGate.app_pushback_instruction_2 && (
                  <Row
                    type="flex"
                    align="middle"
                    style={{ marginTop: "1em" }}
                    // className={
                    //   selectedGate.app_pushback_instruction_2_class_name
                    // }
                    onMouseDown={(e) => e.target.classList.add("pressed")}
                    onMouseUp={(e) => e.target.classList.remove("pressed")}
                    onTouchStart={(e) => e.target.classList.add("pressed")}
                    onTouchEnd={(e) => e.target.classList.remove("pressed")}
                  >
                    <Col
                      className="driver-page-icon-default"
                      style={{ marginTop: -5 }}
                      xs={5}
                      sm={5}
                      md={4}
                      lg={4}
                      xl={4}
                      // style={{ marginTop: -5 }}
                      onClick={() => {
                        console.log("clicked instruction2:", showAirplaneRoute);
                        let filePath =
                          constants.MEDIA_PATH +
                          selectedGate.app_pushback_instruction_2_animation +
                          ".gif";
                        // let filePath = static_image;
                        if (doesFileExist(filePath)) {
                          console.log("airport file 2", doesFileExist(filePath));
                          setShowAirplaneRoute({
                            flag: true,
                            filePath: filePath,
                          });
                          setShowAirplaneRouteModal(true);
                        } else {
                          filePath =
                            constants.MEDIA_PATH +
                            selectedGate.app_pushback_instruction_2_animation +
                            ".pdf";

                          if (doesFileExist(filePath)) {
                            console.log("airport file 2", doesFileExist(filePath));
                            window.open(filePath);
                          }
                        }
                      }}
                    >
                      <img src={info_icon} alt="info_icon" />
                    </Col>
                    <Col span={2}></Col>
                    <Col
                      // className={
                      //   selectedGate.app_pushback_instruction_2_class_name
                      // }
                      xs={17}
                      sm={17}
                      md={18}
                      lg={18}
                      xl={18}
                      // onClick={(e) => {
                      //   showConfirmationModal(selectedGate.bay, selectedGate.app_pushback_instruction_2);
                      // }}
                    >
                      <Button
                        className={`${
                          selectedGate.app_pushback_instruction_2_class_name
                        } ${
                          loadingInstruction.status &&
                          selectedClass ===
                            selectedGate.app_pushback_instruction_2
                            ? "driver-page-instruction-loading-selected"
                            : ""
                        }`}
                        onClick={(e) => {
                          if (selectedInstruction !== 0) {
                            showExistingInstructionModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_2
                            );
                          } else {
                            showConfirmationModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_2
                            ); //show modal for information
                          }

                          // showConfirmationModal(
                          //   selectedGate.bay,
                          //   selectedGate.app_pushback_instruction_2
                          // );
                        }}
                        // disabled={
                        //   (selectedGate.app_pushback_instruction_2_class_name ===
                        //     "driver-page-instruction-disabled" &&
                        //     selectedGate.status !== "P") ||
                        //   loadingInstruction.status ||
                        //   selectedGate.app_pushback_instruction_2_class_name ===
                        //     "driver-page-instruction-selected" ||
                        //   selectedGate.status === "M"
                        // }
                      >
                        {/* {selectedGate.app_pushback_instruction_2} */}
                        <span
                          className={`${
                            selectedGate.app_pushback_instruction_2.length >= 18
                              ? "long_text_driver"
                              : ""
                          }`}
                        >
                          {selectedGate.app_pushback_instruction_2}
                        </span>
                      </Button>
                    </Col>
                  </Row>
                )}
                {selectedGate.app_pushback_instruction_3 && (
                  <Row
                    type="flex"
                    align="middle"
                    style={{ marginTop: "1em" }}
                    // className={
                    //   selectedGate.app_pushback_instruction_3_class_name
                    // }
                    onMouseDown={(e) => e.target.classList.add("pressed")}
                    onMouseUp={(e) => e.target.classList.remove("pressed")}
                    onTouchStart={(e) => e.target.classList.add("pressed")}
                    onTouchEnd={(e) => e.target.classList.remove("pressed")}
                  >
                    <Col
                      className="driver-page-icon-default"
                      style={{ marginTop: -5 }}
                      xs={5}
                      sm={5}
                      md={4}
                      lg={4}
                      xl={4}
                      // style={{ marginTop: -5 }}
                      onClick={() => {
                        console.log("clicked instruction3:", showAirplaneRoute);
                        let filePath =
                          constants.MEDIA_PATH +
                          selectedGate.app_pushback_instruction_3_animation +
                          ".gif";
                        // let filePath = static_image;
                        if (doesFileExist(filePath)) {
                          console.log("airport file 3", doesFileExist(filePath));
                          setShowAirplaneRoute({
                            flag: true,
                            filePath: filePath,
                          });
                          setShowAirplaneRouteModal(true);
                        } else {
                          filePath =
                            constants.MEDIA_PATH +
                            selectedGate.app_pushback_instruction_3_animation +
                            ".pdf";

                          if (doesFileExist(filePath)) {
                            console.log("airport file 3", doesFileExist(filePath));
                            window.open(filePath);
                          }
                        }
                      }}
                    >
                      <img src={info_icon} alt="info_icon" />
                    </Col>
                    <Col span={2}></Col>
                    <Col
                      // className={
                      //   selectedGate.app_pushback_instruction_3_class_name
                      // }
                      xs={17}
                      sm={17}
                      md={18}
                      lg={18}
                      xl={18}
                      // onClick={() => {
                      //   showConfirmationModal(selectedGate.bay, selectedGate.app_pushback_instruction_3); //show modal for information
                      // }}
                    >
                      <Button
                        className={`${
                          selectedGate.app_pushback_instruction_3_class_name
                        } ${
                          loadingInstruction.status &&
                          selectedClass ===
                            selectedGate.app_pushback_instruction_3
                            ? "driver-page-instruction-loading-selected"
                            : ""
                        }`}
                        onClick={(e) => {
                          if (selectedInstruction !== 0) {
                            showExistingInstructionModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_3
                            );
                          } else {
                            showConfirmationModal(
                              selectedGate.bay,
                              selectedGate.app_pushback_instruction_3
                            ); //show modal for information
                          }

                          // showConfirmationModal(
                          //   selectedGate.bay,
                          //   selectedGate.app_pushback_instruction_3
                          // );
                        }}
                        // disabled={
                        //   (selectedGate.app_pushback_instruction_3_class_name ===
                        //     "driver-page-instruction-disabled" &&
                        //     selectedGate.status !== "P") ||
                        //   loadingInstruction.status ||
                        //   selectedGate.app_pushback_instruction_3_class_name ===
                        //     "driver-page-instruction-selected" ||
                        //   selectedGate.status === "M"
                        // }
                      >
                        {/* {selectedGate.app_pushback_instruction_3} */}
                        <span
                          className={`${
                            selectedGate.app_pushback_instruction_3.length >= 18
                              ? "long_text_driver"
                              : ""
                          }`}
                        >
                          {selectedGate.app_pushback_instruction_3}
                        </span>
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
            )}

            
          </Card>

          <div
            style={{ paddingTop: 50, paddingBottom: 50, textAlign: "center" }}
          >
            <Row type="flex" justify="center">
              <img
                src={app_logo}
                alt="app_logo"
                style={{ width: 200, height: "100%" }}
              />
            </Row>
          </div>
          <button
            ref={hiddenButton}
            style={{ background: "#2D3C52", border: "none", color: "#2D3C52" }}
            onClick={() => {
              console.log("hidden button clicked");
              popupAudio.current.play();
            }}
          >
            .
          </button>

          <Modal
            title={null}
            footer={null}
            visible={displayGateList}
            onOk={() => setDisplayGateList(false)}
            onCancel={() => setDisplayGateList(false)}
            style={{ maxWidth: 300 }}
            bodyStyle={{ textAlign: "center", color: "#434343" }}
          >
            {/* <Row justify="start">
              <b>Nearby Bays</b>
            </Row>
            <List
              dataSource={activeGateListByDistance}
              renderItem={(item) => (
                <List.Item
                  onClick={() => {
                    // if (item.status === "M") {
                    //   popupAudio.current.play();
                    // }
                    //get existing local storage
                    let existingGateStorage = window.localStorage.getItem(
                      "gateSelected"
                    );

                    // If no existing data, create an array
                    existingGateStorage = existingGateStorage
                      ? JSON.parse(existingGateStorage)
                      : {};
                    // store new selected gate
                    existingGateStorage = item;

                    setSelectedGate(item);
                    setDisplayGateList(false);

                    // Save back to localStorage
                    setGateLocal(existingGateStorage);
                    window.localStorage.setItem(
                      "gateSelected",
                      JSON.stringify(existingGateStorage)
                    );
                  }}
                >
                  <Typography.Text>{item.bay}</Typography.Text>
                </List.Item>
              )}
            /> */}
            <Row justify="start" style={{ marginTop: "2em" }}>
              <b>All Bays</b>
            </Row>
            <List
              dataSource={originalPushbackData}
              renderItem={(item) => (
                <List.Item
                  onClick={() => {
                    // if (item.status === "M") {
                    //   popupAudio.current.play();
                    // }

                    //get existing local storage
                    let existingGateStorage = window.localStorage.getItem(
                      "gateSelected"
                    );

                    // If no existing data, create an array
                    existingGateStorage = existingGateStorage
                      ? JSON.parse(existingGateStorage)
                      : {};
                    // store new selected gate
                    existingGateStorage = item;

                    setSelectedGate(item);

                    setDisplayGateList(false);
                    setNewGateSelected(true);
                    setAbortFlagValue(false);

                    // Save back to localStorage
                    setGateLocal(existingGateStorage);
                    window.localStorage.setItem(
                      "gateSelected",
                      JSON.stringify(existingGateStorage)
                    );
                  }}
                >
                  <Typography.Text>{item.bay}</Typography.Text>
                </List.Item>
              )}
            />
          </Modal>

          <Modal
            className={"info-modal"}
            title={null}
            footer={null}
            visible={showInformationPopup}
            onOk={() => setShowInformationPopup(false)}
            onCancel={() => setShowInformationPopup(false)}
            style={{ maxWidth: 300 }}
            bodyStyle={{ textAlign: "center", color: "#434343" }}
          >
            <Row>
              <Col span={24}>
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    borderRadius: "20px",
                    width: "100%",
                    height: 48,
                    background: "#1C60E6",
                    color: "#fff",
                    paddingLeft: 15,
                    lineHeight: "1em",
                    marginTop: "1.5em",
                    textAlign: "left",
                  }}
                >
                  <Col span={3}>
                    <img src={icon_hand} alt="icon_hand" />
                  </Col>
                  <Col span={21}>
                    <b>Wait for instructions</b>
                  </Col>
                </Row>
                <div className="driver-modal-button-desc">
                  Wait for instructions. Then select pushback based on
                  instructions.
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Row
                  type="flex"
                  justify="start"
                  align="middle"
                  style={{
                    borderRadius: "20px",
                    width: "100%",
                    height: 48,
                    background: "#4BC996",
                    color: "#fff",
                    paddingLeft: 15,
                    lineHeight: "1em",
                    marginTop: "1em",
                    textAlign: "left",
                  }}
                >
                  <Col span={3}>
                    <img src={icon_check} alt="icon_check" />
                  </Col>
                  <Col span={21}>
                    <b>Pushback selected</b>
                  </Col>
                </Row>
                <div className="driver-modal-button-desc">
                  Your input has been received. Please proceed with pushback.
                </div>
              </Col>
            </Row>
          </Modal>

          {/* confirm modal for update pushback */}
          <Modal
            className={"info-modal"}
            title={null}
            footer={null}
            visible={showConfirmationPushbackPopup}
            onOk={() => setShowConfirmationPushbackPopup(false)}
            onCancel={() => setShowConfirmationPushbackPopup(false)}
            style={{ maxWidth: 320 }}
            bodyStyle={{ textAlign: "center", color: "#434343" }}
            confirmationInstruction={confirmationInstruction}
          >
            <Row style={{ paddingTop: "50px" }}>
              <Col span={24}>
                <Row type="flex" justify="center" align="middle">
                  <Col span={21}>
                    <div className="confirm_text">You have selected</div>
                  </Col>
                </Row>
                <Row type="flex" justify="center" align="middle">
                  <Col span={21}>
                    <div className="confirm_instruction">
                      {confirmationInstruction.instruction}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row style={{ paddingTop: "20px", paddingBottom: "30px" }}>
              <Col span={24}>
                <Row type="flex" justify="space-around" align="middle">
                  <Col>
                    <Button
                      className="confirm_button"
                      onClick={() => setShowConfirmationPushbackPopup(false)}
                    >
                      <img src={close_icon} alt="close_icon" />
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className="confirm_button"
                      onClick={() => {
                        let data = {
                          action: constants.ACTION_UPDATE_VALIDATE_INSTRUCTION,
                          instruction: {
                            gate: confirmationInstruction.bay,
                            pushback_direction:
                              confirmationInstruction.instruction,
                            previous_pushback_instruction_driver: prevInstructionSelected,
                            airport_pass: user
                            ? user.idToken.payload.name
                            : userLocal.idToken.payload.name
                          },
                          access_token: user.accessToken.jwtToken,
                        };
                        setPreviousInstruction(data.instruction.previous_pushback_instruction_driver);
                        setLoadingInstruction({ status: true, data: data });
                        setPassConfirmation(true);
                        setSelectedClass(confirmationInstruction.instruction);
                        dispatch(wsSend(data));
                        setShowConfirmationPushbackPopup(false);
                        setLoadingSelected(true);
                      }}
                    >
                      <img src={check_icon} alt="check_icon" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal>

          {/* existing instructin modal for update pushback */}
          <Modal
            className={"info-modal selection-modal"}
            title={null}
            footer={null}
            visible={showExistingPushbackPopup}
            onOk={() => setShowExistingPushbackPopup(false)}
            onCancel={() => setShowExistingPushbackPopup(false)}
            // style={{ maxWidth: 400 }}
            bodyStyle={{ textAlign: "center", color: "#434343", }}
            confirmationInstruction={confirmationInstruction}
          >
            <Row style={{ paddingTop: "50px" }}>
              <Col span={24}>
                <Row type="flex" justify="center" align="middle" style={{ marginBottom: '20px' }}>
                  <Col span={21}>
                  <  WarningFilled style={{ fontSize: '65px' }} />
                  </Col>
                </Row>
                <Row type="flex" justify="center" align="middle">
                  <Col span={21}>
                    {/* <div className="confirm_text">You have an existing instruction. Do you want to update this? </div> */}
                    {/* <div className="confirm_text">This will override an existing selection at this stand. Please only make selection if you are doing live operations. Confirm to override? </div> */}
                    <div className="confirm_text2" style={{ marginBottom: '15px' }}>
                      This overrides existing selection.
                    </div>
                    <div className="confirm_text2" style={{ marginBottom: '20px' }}>
                      Proceed ONLY IF doing LIVE ops at Stand {confirmationInstruction.bay}.
                    </div>
                    <div className="confirm_text2" style={{ marginBottom: '20px' }}>
                      Confirm? 
                    </div>
                  </Col>
                </Row>
                {/* <Row type="flex" justify="center" align="middle">
                  <Col span={21}>
                    <div className="confirm_instruction">
                      Existing instruction
                    </div>
                  </Col>
                </Row> */}
              </Col>
            </Row>
            <Row style={{ paddingTop: "20px", paddingBottom: "30px" }}>
              <Col span={24}>
                <Row type="flex" justify="space-around" align="middle">
                  <Col>
                    <Button
                      className="confirm_button"
                      onClick={() => setShowExistingPushbackPopup(false)}
                    >
                      <img src={close_icon} alt="close_icon" />
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      className="confirm_button"
                      onClick={() => {
                        showConfirmationModal(
                          confirmationInstruction.bay,
                          confirmationInstruction.instruction
                        );
                        setShowExistingPushbackPopup(false);
                      }}
                    >
                      <img src={check_icon} alt="check_icon" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Modal>

          <Modal
            className={"airplane-modal"}
            title={null}
            footer={null}
            maskClosable={false}
            // visible={showAirplaneRouteModal}
            visible={showAirplaneRoute.flag}
            onOk={() => {
              setShowAirplaneRoute({ flag: false, filePath: null });
              setShowAirplaneRouteModal(false);
              setRotateClockwiseValue(0);
              // setIdleState('Idle');
            }}
            onCancel={() => {
              setShowAirplaneRoute({ flag: false, filePath: null });
              setShowAirplaneRouteModal(false);
              setRotateClockwiseValue(0);
              checkTimeSessionToken();
              // reloadPage();
              // setIdleState('Idle');
            }}
            // style={{ borderRadius: 5, boxShadow: "0px 4px 30px #434343" }}
            style={{ borderRadius: 5, }}
            bodyStyle={{ textAlign: "center", color: "#434343", padding: 15 }}
          >
            <div className="route_container">
              <Spin size="middle" spinning={loadingImg}>
              {/* <Spin size="middle" spinning={!showAirplaneRoute.flag || loadingImg}> */}
              <div className="image_con">
                {showAirplaneRoute.filePath && (
                  <img
                    src={showAirplaneRoute.filePath}
                    alt="flight_pushback_route"
                    style={{ transform: `rotate(${rotateClockwiseValue}deg)` }}
                    id="image_gif"
                    // className="image_gif"
                    className={`image_gif ${
                      rotateClockwiseValue === 90 || rotateClockwiseValue === 270 || rotateClockwiseValue === -90 || rotateClockwiseValue === -270
                        ? "image_gif_landscape"
                        : "image_gif_portrait"
                    }`}
                  />
                )}
              </div>

              <div className="button_con">
                <Row justify="space-around" align="center">
                  <Col span={6}>
                      <Button
                        style={{
                          backgroundColor: "#1C60E5",
                          borderRadius: 5,
                          width: "100%",
                          height: "40px",
                          color: '#fff'
                        }}
                        className="rotate_btn"
                        onClick={(e) => {
                          e.preventDefault();
                          rotateImageCounterClockwise();
                        }}
                      >
                        {/* Rotate <span> {' '} Counter Clockwise</span>  */}
                        <img src={clockwise_icon} alt="clockwise_icon" style={{ width: 30 }} />
                      </Button>
                    </Col>
                  <Col span={6}>
                    <Button
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: 5,
                        width: "100%",
                        height: "40px",
                        border: '1px solid #1C60E5',
                        color: '#1C60E5'
                      }}
                      className="rotate_btn"
                      onClick={() => {
                        const image = document.getElementById('image_gif');
                        image.style.transform = 'rotate(0deg)';
                        setRotateClockwiseValue(0);
                      }}
                    >
                      Reset
                    </Button>
                  </Col>
                  <Col span={6}>
                    <Button
                      style={{
                        backgroundColor: "#1C60E5",
                        borderRadius: 5,
                        width: "100%",
                        height: "40px",
                        color: '#fff'
                      }}
                      className="rotate_btn"
                      onClick={(e) => {
                        e.preventDefault();
                        rotateImageClockwise();
                      }}
                    >
                      {/* Rotate <span> {' '} Clockwise</span>  */}
                      <img src={counter_icon} alt="counter_icon" style={{ width: 30 }} />
                    </Button>
                  </Col>
                </Row>
                
                
              </div>
              
              
              </Spin>
            </div>
            
          </Modal>

          <Modal
            title={null}
            visible={gpsDisplay}
            footer={null}
            onCancel={() => setGpsDisplay(false)}
            style={{ maxWidth: 300, maxHeight: 263 }}
            /* bodyStyle={{ textAlign: "center", color: "#434343", padding: 15 }} */
          >
            <Row
              type="flex"
              justify="center"
              style={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "20px",
                display: "flex",
                alignItems: "center",
                lineHeight: "23px",
                textAlign: "center",
                letterSpacing: "0.03em",
                color: "#434343",
                marginTop: "1.5em",
              }}
            >
              You are at bay
            </Row>
            <Row
              type="flex"
              justify="center"
              style={{
                fontFamily: "Lato",
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "50px",
                display: "flex",
                alignItems: "center",
                textAlign: "center",
                letterSpacing: "0.03em",
                color: "#434343",
              }}
            >
              {gpsSelectedBay}
            </Row>
            <Row type="flex" justify="center" style={{}}>
              <Button
                style={{
                  backgroundColor: "#1C60E5",
                  borderRadius: 5,
                  width: "170px",
                  height: "40px",
                }}
                onClick={() => {
                  /* setGPSasLocation(); */
                  if (sortedGPSValue.length > 3) {
                    setActiveGateListByDistance(sortedGPSValue.slice(0, 3));
                  } else {
                    setActiveGateListByDistance(sortedGPSValue);
                  }
                  setAbortFlagValue(false);
                  setSelectedGate(sortedGPSValue[0]);
                  setGpsDisplay(false);
                }}
              >
                <Row
                  type="flex"
                  justify="center"
                  style={{
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "19px",
                    display: "flex",
                    alignItems: "center",
                    lineHeight: "22px",
                    textAlign: "center",
                    letterSpacing: "0.1em",
                    color: "#FFFFFF",
                  }}
                >
                  CONFIRM
                </Row>
              </Button>
            </Row>
            <Row
              type="flex"
              justify="center"
              style={{ marginTop: "1em", marginBottom: "1.5em" }}
            >
              <Button
                style={{ border: "none", boxShadow: "none" }}
                onClick={() => setGpsDisplay(false)}
              >
                <Row
                  type="flex"
                  justify="center"
                  style={{
                    fontFamily: "Lato",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "15px",
                    display: "flex",
                    alignItems: "center",
                    lineHeight: "18px",
                    textAlign: "center",
                    letterSpacing: "0.1em",
                    color: "#1C60E6",
                    border: "none",
                  }}
                >
                  CANCEL
                </Row>
              </Button>
            </Row>
          </Modal>

          {/* <Modal
            className={"abort-modal pulse-modal"}
            title={null}
            footer={null}
            maskClosable={false}
            zIndex={3000}
            visible={showMismatchPopup}
            onOk={() => {
              setShowMismatchPopup(false);
              setAbortFlagValue(true);
              setPassConfirmation(false);
              setShowAirplaneRoute({ flag: false, filePath: null });
            }}
            onCancel={() => {
              popupAudio.current.pause();
              setShowMismatchPopup(false);
              setAbortFlagValue(true);
              setPassConfirmation(false);
              setShowAirplaneRoute({ flag: false, filePath: null });
            }}
            style={{ maxWidth: 300, }}
            bodyStyle={{ textAlign: "center", color: "#434343" }}
          >
            <Row
              type="flex"
              justify="center"
              style={{ fontSize: 20, color: "#EF1212" }}
            >
              <b>STOP PUSHBACK</b>
            </Row>
            <Row type="flex" justify="center" style={{ marginTop: "1em" }}>
              <img src={icon_warning} alt="icon_warning" />
            </Row>
            <Row
              type="flex"
              justify="center"
              style={{ marginTop: "1em", fontSize: 20 }}
            >
              Please await further instructions
            </Row>
          </Modal> */}
          
          <Modal
            className={"abort-modal pulse-modal"}
            title={null}
            footer={null}
            zIndex={3000}
            maskClosable={false}
            visible={showInstructionMismatchPopup}
            onOk={() => {
              setAbortFlagValue(true);
              setPassConfirmation(false);
              // setShowAirplaneRoute({ flag: false, filePath: null });
              setShowInstructionMismatchPopup(false);
            }}
            onCancel={() => {
              popupAudio.current.pause();
              setAbortFlagValue(true);
              setPassConfirmation(false);
              // setShowAirplaneRoute({ flag: false, filePath: null });
              setShowInstructionMismatchPopup(false);
            }}
            style={{ maxWidth: 300 }}
            bodyStyle={{ textAlign: "center", color: "#434343" }}
            /* className={"animateModal"} */
          >
             <Row type="flex" justify="center" style={{ marginTop: "1em", }}>
                <img src={icon_warning} alt="icon_warning" />
              </Row>
            <Row
              type="flex"
              justify="center"
              style={{ fontSize: 17, color: "#EF1212", marginTop: "1em" }}
            >
              <b>Warning: Pushback procedure selection has been changed while you were viewing the animation.</b>
            </Row>
            <Row
              type="flex"
              justify="center"
              style={{ marginTop: "1em", fontSize: 16 }}
            >
              Please confirm if this animation is showing the correct procedure.
            </Row>
          </Modal>

        </Spin>
        
      </div>
    </React.Fragment>
  );
};

export default Driver;
